export function isEmbeddedPurchasesRoute(pathname, search) {
  const embed = new URLSearchParams(search).get('embed');
  return pathname.startsWith('/compras') && (embed === '1' || embed === 'true');
}
